import { LogNguoiDung } from "../lognguoidung/LogNguoiDung";
import { NhanVienResponse } from "../nhanvien/NhanVien";
import { TaiLieu } from "../nhanvien/TaiLieu";

export class HopDongResponse {
    "nhanVienInfo": NhanVienResponse;
    "dsHopDong": Array<HopDong>
}

export class HopDong {
    "soHopDong": string;
    "ngayBatDau": Date;
    "ngayKetThuc": Date;
    "ngayKy": Date;
    "trangThai": number;
    "loaiHopDong": string;
    "idLoaiHopDong": number;
    "isDongBHXH": boolean;
    "noiKy": string;
    "noiDung": string;
    "id": number;
    "tenNguoiKy": string;
    "dsTaiLieu": Array<TaiLieu>;
}

export class ChiTietHopDongResponse {
    "hoTen": string;
    "ma": string;
    "viTriCongViec": string;
    "loaiHopDong": string;
    "idLoaiHopDong": number;
    "soHopDong": string;
    "ngayBatDau": Date;
    "ngayKetThuc": Date;
    "ngayKy": Date;
    "trangThai": number;
    "avatar": string;
    "isDongBHXH": boolean;
    "email": string;
    "tenDonVi": string;
    "id": number;
    "gioiTinh": boolean;
    "ngaySinh": Date;
    "tenNguoiKy": string;
    "noiKy": string;
    "noiDung": string;
    "idDonVi": number;
    "idChucVu": number;
    "bacLuong": Array<BacLuongResponse>;
    "phuCap": Array<PhuCapResponse>;
    "dsTaiLieu": Array<TaiLieu>;
    "idHopDongDienTu": number;
    "tenFileKySo": string;
    "fileKySo": string;

};

export class BacLuongResponse {
    "idDonVi": number;
    "tenDonVi": string;
    "soQD": string;
    "ngayKyQD": Date;
    "ngayBatDau": Date;
    "ngayKetThuc": Date;
    "tenChucVu": string;
    "heSo": number;
    "mucLuong": number;
    "moTa": string;
    "idQuyetDinhBacLuong": number;
    "idChucVu": number;
    "idHeSoLuong": number;
    "mucLuongThucNhan": number;
    "idNhomNhanSu": number;
    "dsTaiLieu": Array<TaiLieu>;
    "tenBacLuong": string;
    "phuCap": Array<PhuCapResponse>;
};

export class PhuCapResponse {
    "tenPhuCap": string;
    "loaiPhuCap": string;
    "mucPhuCap": number;
    "moTa": string;
    "idPhuCapNhanSu": number;
    "idPhuCap": number;
    "cachTinh": number;
};

export class PhuCap {
    "idLoaiPhuCap": number;
    "ten": string;
    "moTa": string
}

export class LoaiHopDong {
    "ten": string; 
    "id": number;
    "thuTu": number;
}

export class HopDongRequest{
    "files": Array<any>;
    "id": number | null;
    "tenNguoiKy": string;
    "idNhanVien": number;
    "idLoaiHopDong": number;
    "soHopDong": string;
    "ngayBatDau": string;
    "ngayKetThuc": string;
    "ngayKy": string;
    "trangThai": number;
    "noiDung": string;
    "isDongBHXH": boolean;
    "noiKy": string;
    "idsTaiLieuHopDongXoa": Array<number>;
    "idHopDongDienTu": number;
    "idQDBLCu": number | null;
}

export class QDBLRequest {
    "files": Array<any>;
    "id": number | null;
    "idHopDong": number;
    "idDonVi": number;
    "idNhomNhanSu": number;
    "idHeSoLuong": number;
    "idChucVu": number;
    "soQD": string;
    "ngayKyQD": string;
    "ngayBatDau": string;
    "ngayKetThuc": string;
    "mucLuongThucNhan": number;
    "idsTaiLieuQDBLXoa": Array<number>;
}

export class HopDongHetHan {
    "id": number;
    "idNhanVien": number;
    "loai": string;
    "soQuyetDinh": string;
    "ngayBatDau": string;
    "ngayKetThuc": string;
    "thoiHan": number;
    "loaiHopDong": string;
    "hoTen": string;
    "tenChucVu": string;
    "tenDonVi": string;
}

export class LayTienTheoPhuCapResponse {
    "id": number;
    "idDonVi": number;
    "idChucVu": number;
    "idPhuCap": number;
    "tienPhuCap": number;
}

/// Thiết lập hợp đồng điện tử: các thông tin được điền vào tệp mẫu HĐLĐ
/// Chi tiết hợp đồng điện tử đã lưu
export class ChiTietHopDongDienTuResponse {
    "id": number;
    "idNhanVien": number;
    "hoTen": string;
    "tenLoaiHopDong"?: string;
    "tenChucVu"?: string;
    "tenDonVi"?: string;
    "idNVKyNhay": number;
    "idNVTheoDoi": number;
    "idLoaiHopDong": number;
    "idChucVu": number;
    "soHopDong": string;
    "idGiamDoc": number;
    "tenGiamDoc": string;
    "ngayBatDau": string;
    "ngayKetThuc": string | null;
    "ngayKy": string | null;
    "trangThai": number;
    "thoiGianLamViec": string;
    "diaDiemLamViec": string;
    "nguonFile": number;
    "idTaiLieu": number;
    "tenTep": string;
    "duongDan": string;
    "dinhDang": string;
    "idHopDongMoi": number;
    "logs"?: Array<LogNguoiDung>;
}

/// Người ký nháy phê duyệt hoặc trả lại hợp đồng điện tử
export class PheDuyetHopDongDienTuRequest {
    "id": number;
    /// true: phê duyệt và chuyển cho người lao động ký, false: trả lại người trình
    "isDuyet": boolean;
    "lyDo"?: string;
}

/// Dữ liệu lưu hợp đồng điện tử, gửi lên dạng multipart vì có thể kèm tệp tải lên
export class LuuHopDongDienTuRequest {
    "id"?: number | null;
    "idNhanVien": number;
    "idNVKyNhay": number;
    "idNVTheoDoi"?: number;
    "idLoaiHopDong": number;
    "idChucVu": number;
    "soHopDong"?: string;
    "ngayBatDau": string;
    "ngayKetThuc": string | null;
    "ngayKy"?: string | null;
    "trangThai"?: number;
    "thoiGianLamViec": string;
    "diaDiemLamViec": string;
    /// 1: hệ thống tạo từ tệp mẫu, 2: người dùng tải tệp lên
    "nguonFile": number;
    "file"?: File | null;
    /// true: lưu xong trình luôn cho người ký nháy, false: chỉ lưu lại
    "isTrinh"?: boolean;
    /// Ý kiến người dùng nhập khi trình, lưu vào cột ý kiến của lịch sử thao tác
    "lyDo"?: string;
    "idHopDongCu": number;
}

export class HopDongDienTu {
    "idTaiLieuMau": number;
    /// Người lao động ký hợp đồng, 0 nếu chỉ tạo mẫu trống
    "idNhanVien": number;
    /// Họ tên người lao động, chỉ dùng để hiển thị lại cho người dùng
    "hoTen": string;
    "idLoaiHopDong": number;
    "tenLoaiHopDong": string;
    "ngayBatDau": string;
    "ngayKetThuc": string | null;
    "idChucVu": number;
    "tenChucVu": string;
    "thoiGianLamViec": string;
    "diaDiemLamViec": string;
}
